export default "__VITE_ASSET__Tbd5mTaw__"